import { isBrowser } from './../utils';

require('es6-promise').polyfill();
require('isomorphic-fetch');

export default (url: string, headers?: Headers) => {
  const CARBON_BASE_URL = process?.env?.CARBON_BASE_URL ?? '';

  const DefaultHeaders = new Headers({
    Authorization: `Basic ${Buffer.from(
      process.env['ALL_PERMS_CREDS'] ?? ''
    ).toString('base64')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  });
  if (headers) {
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
  }

  const ABSOLUTE_URL = `${isBrowser() ? '' : CARBON_BASE_URL}${url}`;
  return fetch(ABSOLUTE_URL, {
    method: 'GET',
    headers: headers ?? DefaultHeaders,
    credentials: 'same-origin',
  });
};
